<div *ngIf="filterItems && controls">
    <div [ngClass]="{'row': true, 'small-up-1': true, 'medium-up-3': true, 'large-up-8': wideRow, 'large-up-4': !wideRow}">
        <div class="column" *ngFor="let item of filterItems | arrayFilter: this:filterThisItem">
            <app-question
                    (controlValueChange)="filterUpdated($event, questions[item.property])"
                    (keydown)="keydown($event)"
                    [question]="questions[item.property]">
            </app-question>
            <ng-template [ngIf]="item.inputType === 'date' && questions[item.property].input.control.value">
                <app-question
                    (controlValueChange)="filterUpdated($event, questions[this.dateOperator(item)])"
                    [question]="questions[this.dateOperator(item)]"
                    (keydown)="keydown($event)"
                ></app-question>
            </ng-template>
        </div>
    </div>
    <div *ngIf="hasLessCommon" class="row">
        <div class="column">
            <app-question [question]="questions.lessCommon" (controlValueChange)="onLessCommonChange($event)"></app-question>
        </div>
    </div>
    <div class="row small-up-1 margin-top-sm">
        <div class="column">
            <ng-container [ngTemplateOutlet]="compactButtons ? compactButtonList : standardButtonList"></ng-container>
            <div *ngIf="storedFilterQuestion" class="row">
                <div class="columns small-12 medium-5 large-4 margin-left-sm">
                    <app-question
                                  [question]="storedFilterQuestion"
                                  (controlValueChange)="selectedFilterChange($event)"></app-question>
                </div>
            </div>
        </div>
    </div>
    <div class="small-up-1 margin-top-md margin-bottom-md">
        <div *ngIf="filterOutput; else emptyFilter;" class="column text-small">
            <mat-icon *ngIf="filtersChanged && !filtersMatch"
                      class="green"
                      matTooltip="Click search to update the data in the table">info_outline</mat-icon>{{filterOutput}}</div>
        <div *ngIf="notImmediateLoad" class="column text-small">
            This table has delayed loading until you enter some filters or click search.
        </div>
        <div class="column text-small">{{currentExportStatus}}</div>
    </div>
</div>

<ng-template #emptyFilter><div class="column text-small">
    <mat-icon class="green" matTooltip="Use the filters above to create additive filters and further reduce the list below.
    You will see your filters written out here as you make changes.
    Then click search or press ENTER to search with your updated filters.">info_outline</mat-icon>
    Your search will be applied with the default filters for this list.</div></ng-template>


<ng-template #compactButtonList>
    <app-button-list>
        <app-button
            #searchButton
            [loading]="loading"
            [toolTip]="searchButtonTooltip"
            (clickedEvent)="search()">Search </app-button>
        <app-button
                [loading]="loading"
                toolTip="Click to reset these filters"
                [buttonConfig]="buttonConfig"
                (clickedEvent)="resetFilters()">Reset Filters </app-button>
        <app-button *ngIf="initialFilter && !selectedFilter?.id"
                    toolTip="Click to store these filters."
                    [loading]="loading"
                    [disabled]="filtersChanged"
                    [buttonConfig]="buttonConfig"
                    (clickedEvent)="storeFilters()">Store Filters </app-button>
        <app-button *ngIf="initialFilter && selectedFilter && selectedFilter.id > 0"
                    toolTip="Click to update this stored filter."
                    [loading]="loading"
                    [disabled]="filtersChanged"
                    [buttonConfig]="buttonConfig"
                    (clickedEvent)="updateFilters()">
            Update filters
         </app-button>
        <app-button *ngIf="initialFilter && selectedFilter && selectedFilter.id > 0"
                    toolTip="Click to remove the selected stored filter"
                    [loading]="loading"
                    [buttonConfig]="buttonConfig"
                    (clickedEvent)="removeFilters()">Remove Stored Filter </app-button>
        <mat-icon
                *ngIf="initialFilter && selectedFilter && filtersChanged"
                class="green"
                matTooltip="Your filters have changed click search to be update the selected filter.">info_outline</mat-icon>
        <app-button
                *ngIf="mayExport"
                [disabled]="!dataLoaded"
                [loading]="loading"
                toolTip="Click to export to Excel"
                [buttonConfig]="buttonConfig"
                (clickedEvent)="exportAsExcel()"
                [toolTip]="'Export as excel'">Export </app-button>
        <mat-icon
                *ngIf="mayExport && filtersChanged && !filtersMatch"
                class="green"
                matTooltip="Your filters have changed click search to be able to export the updated data.">info_outline</mat-icon>
    </app-button-list>
</ng-template>
<ng-template #standardButtonList>
    <app-button-list>
        <app-button
            #searchButton
            [loading]="loading"
            [buttonSize]="'Large'"
            [toolTip]="searchButtonTooltip"
            (clickedEvent)="search()">Search </app-button>
    </app-button-list>
    <app-button-list>
        <app-button
                [loading]="loading"
                toolTip="Click to reset these filters"
                [buttonConfig]="buttonConfig"
                (clickedEvent)="resetFilters()">Reset Filters </app-button>
        <app-button *ngIf="initialFilter && (!selectedFilter?.id || !storedFilterQuestion)"
                    toolTip="Click to store these filters."
                    [loading]="loading"
                    [disabled]="filtersChanged"
                    [buttonConfig]="buttonConfig"
                    (clickedEvent)="storeFilters()">Store Filters </app-button>
        <app-button *ngIf="initialFilter && selectedFilter && storedFilterQuestion && selectedFilter.id > 0"
                    toolTip="Click to update this stored filter."
                    [loading]="loading"
                    [disabled]="filtersChanged"
                    [buttonConfig]="buttonConfig"
                    (clickedEvent)="updateFilters()">
            Update filters
         </app-button>
        <app-button *ngIf="initialFilter && selectedFilter && storedFilterQuestion && selectedFilter.id > 0"
                    toolTip="Click to remove the selected stored filter"
                    [loading]="loading"
                    [buttonConfig]="buttonConfig"
                    (clickedEvent)="removeFilters()">Remove Stored Filter </app-button>
        <mat-icon
                *ngIf="initialFilter && selectedFilter && filtersChanged"
                class="green"
                matTooltip="Your filters have changed click search to be update the selected filter.">info_outline</mat-icon>
        <app-button
                *ngIf="mayExport"
                [disabled]="!dataLoaded"
                [loading]="loading"
                toolTip="Click to export to Excel"
                [buttonConfig]="buttonConfig"
                (clickedEvent)="exportAsExcel()"
                [toolTip]="'Export as excel'">Export </app-button>
        <mat-icon
                *ngIf="mayExport && filtersChanged && !filtersMatch"
                class="green"
                matTooltip="Your filters have changed click search to be able to export the updated data.">info_outline</mat-icon>
    </app-button-list>
</ng-template>